import { FunctionComponent, MouseEvent } from 'react';
import styles from './Item.module.scss';
import clsx from 'clsx';

interface ItemProps {
    label: string;
    className?: string;
    onClick?: () => void;
}

export const Item: FunctionComponent<ItemProps> = props => {
    const clickHandler = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick?.();
    };

    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={clickHandler}
        >
            <span className={styles.label}>{props.label}</span>
        </div>
    );
};

export default Item;
